var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg069LogIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "current"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M432,0H80C35.888,0,0,35.888,0,80v40c0,11.046,8.954,20,20,20s20-8.954,20-20V80c0-22.056,17.944-40,40-40h352 c22.056,0,40,17.944,40,40v352c0,22.056-17.944,40-40,40H80c-22.056,0-40-17.944-40-40v-40c0-11.046-8.954-20-20-20 s-20,8.954-20,20v40c0,44.112,35.888,80,80,80h352c44.112,0,80-35.888,80-80V80C512,35.888,476.112,0,432,0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.919,213.567l-74.784-74.716c-7.814-7.807-20.477-7.801-28.284,0.013c-7.807,7.814-7.801,20.477,0.013,28.284 l74.778,74.709c7.798,7.798,7.798,20.486,0,28.284c-0.029,0.029-0.058,0.059-0.087,0.088l-74.784,75.716 c-7.762,7.859-7.684,20.522,0.175,28.284c3.897,3.85,8.976,5.771,14.053,5.771c5.16,0,10.318-1.985,14.23-5.946l74.746-75.677 C359.321,274.979,359.304,236.952,335.919,213.567z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233,236H20c-11.046,0-20,8.954-20,20c0,11.046,8.954,20,20,20h213c11.046,0,20-8.954,20-20S244.046,236,233,236z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg069LogIn);
export default __webpack_public_path__ + "static/media/069-log-in.be09cc0361fcd7c3f1738ff2eef2cf30.svg";
export { ForwardRef as ReactComponent };